import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TT3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TT3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_547)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#E31D1C"
        />
        <mask
          id="mask0_1813_547"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_547)">
          <path
            d="M29.5593 29.4958L29.0164 29.9397L28.537 29.4279L-1.80706 -2.97079L-2.35538 -3.55623L-1.73446 -4.06404L1.36189 -6.59636L1.90473 -7.04031L2.3841 -6.52848L32.7282 25.8702L33.2765 26.4557L32.6556 26.9635L29.5593 29.4958Z"
            fill="#272727"
            stroke="#F7FCFF"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_547">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TT3224Icon;
